import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import CarHireDiscountUpcomingOrderCarousel from './CarHireDiscountUpcomingOrderCarousel'
import LayoutContainer from 'components/Common/LayoutContainer'
import CarHireDiscountUpcomingOrderCarouselLoadingSkeleton from './CarHireDiscountUpcomingOrderCarouselLoadingSkeleton'

interface Props {
  orders: Array<App.Order>;
  title?: string;
  fetching?: boolean;
}

function CarHireDiscountUpcomingOrdersCarousels(props: Props) {
  const { orders, title, fetching } = props

  const isFetching = fetching || !orders.length

  return <Group direction="vertical" gap={24} desktopGap={40}>
    <LayoutContainer>
      {title && <Heading variant="heading2">{title}</Heading>}
    </LayoutContainer>
    {isFetching && <CarHireDiscountUpcomingOrderCarouselLoadingSkeleton />}
    {!isFetching && orders.map((order) => (
      <CarHireDiscountUpcomingOrderCarousel key={order.id} order={order} />
    ))}
  </Group>
}

export default CarHireDiscountUpcomingOrdersCarousels
